export const getMenu = state => state.menuR.menu;
export const getSuccess = state => state.connections.connection;
export const getResetSuccess = state => state.connections.reset;
export const getError = state => state.connections.error;
export const getResetError = state => state.connections.resetError;
export const getFavoriteStore = state => state.connections.favoriteStore;
export const getResetFinish = state => state.connections.resetFinish;

